<template>
  <div>
    <!-- <div class="showlabel">
      <h4>选择题库</h4>
      <div class="testtype">组件模式：智能组卷</div>
      <div class="testtype">命题方式：统一命题</div>
     
    </div> -->
    <!-- 难易度 -->
    <facilityPage
      v-if="
        (groupmode === 'unified_difflever' ||
          groupmode === 'random_difflever') &&
        loading == false
      "
      :getData="getData"
      ref="facilitypage"
    />
    <div class="baic_content" v-else>
      <!-- 表单内容 -->
      <div class="hos_table" v-loading="loading">
        <el-form :v-model="getData">
          <el-table
            :data="getData"
            style="width: 100%"
            :summary-method="getSummaries"
            show-summary
            :row-class-name="tableRowClassName"
            :header-cell-style="{
              'background-color': '#8FCBFF',
              color: '#333333',
              height: '60px',
            }"
          >
            <el-table-column type="index" label="序号" width="50">
            </el-table-column>
            <el-table-column prop="StyleName" label="题型">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.StyleName"
                  maxlength="10"
                  class="super_input"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="Total" label="题数"> </el-table-column>
            <el-table-column prop="Score" label="分值">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.Score"
                  class="small_input"
                  @change="checkscore(scope.row.Score, scope.$index)"
                ></el-input
                >分
              </template>
            </el-table-column>
            <el-table-column prop="TestCount" label="题量">
              <template slot-scope="scope">
                <el-input
                  v-model.trim="scope.row.TestCount"
                  class="small_input"
                  @change="checkscore(scope.row, scope.$index, 'test')"
                ></el-input
                >题
              </template>
            </el-table-column>
            <el-table-column prop="Explain" label="题型说明" width="430px">
              <template slot-scope="scope">
                <el-input
                  type="textarea"
                  class="long_input"
                  :autosize="{ minRows: 2, maxRows: 4 }"
                  v-model.trim="scope.row.Explain"
                  maxlength="200"
                  show-word-limit
                  resize="none"
                >
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == 0 }"
                  @click="onmoveup(scope.$index, scope.row)"
                  :disabled="scope.$index == 0"
                  >上移</el-button
                >
                <el-button
                  type="text"
                  :class="{ nomove: scope.$index == getData.length - 1 }"
                  @click="onmovedown(scope.$index, scope.row)"
                  :disabled="scope.$index == getData.length - 1"
                  >下移</el-button
                >
                <el-button type="text" @click="deletes(scope.$index)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-form>
      </div>
    </div>
    <!-- 按钮 -->
    <div class="operation">
      <el-button
        class="succ_btn"
        @click="
          cutcoms(4);
          cutcomsfour(2);
        "
        >上一步</el-button
      >
      <el-button type="success" class="submit_btn" @click="isselect"
        >确定</el-button
      >
    </div>
  </div>
</template>

<script>
import qs from "qs";
import getappstyle from "@/api/questionbank";
import editqusetionbank from "@/api/editqusetionbank";
import { getTestStyle } from "@/api/examination.js";
import facilityPage from "../../newaddpaper/components/facilityPage.vue";
export default {
  props: ["cutcoms", "cutcomsfour"],
  data() {
    return {
      textarea: "",
      input: "",
      redcudesum: "", //总分数
      reducesumid: "", //总提数
      loading: false, //
      groupmode: "", //组卷模式
      getData: [
        // {
        //   id: 1,
        //   StyleName: "A题型",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        // },
        // {
        //   StyleName: "X题型",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和正确、错误两个选项。选对得分，错选、不选均不得分。",
        // },
        // {
        //   StyleName: "填空题",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain: "在下列空格中填入适当内容，使句子意思完整。",
        // },
        // {
        //   StyleName: "判断题",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        // },
        // {
        //   StyleName: "名词解释",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        // },
        // {
        //   StyleName: "问答题",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和A、B、C、D、E五个选项，其中有一个正确选项。选对得分，多选、错选、不选均不得分。",
        // },
        // {
        //   StyleName: "B题型",
        //   Total: "100题",
        //   Score: 50,
        //   TestCount: 50,
        //   Explain:
        //     "包括题干和正确、错误两个选项。选对得分，错选、不选均不得分。",
        // },
      ],
    };
  },
  components: {
    facilityPage,
  },
  methods: {
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    checkscore(Score, indexs, istest) {
      // 2024/3/20 产品要求题数输入0时删除该数据
      if (Score.TestCount == 0) {
        this.getData.splice(indexs, 1);
      }
      if (istest == "test") {
        if (isNaN(Number(Score.TestCount))) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: "请输入正确的题量值",
            type: "error",
          });
        } else if (Number(Score.TestCount) > Score.Total) {
          this.getData[indexs].TestCount = "";
          this.$message({
            showClose: true,
            message: `题量不能大于该题型${Score.StyleName}的总题量:${Score.Total}`,
            type: "error",
          });
        }
        return;
      }
      //检查分数范围。
      if (isNaN(Number(Score))) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "请输入正确的分数值",
          type: "error",
        });
      } else if (Number(Score) > 99) {
        this.getData[indexs].Score = "";
        this.$message({
          showClose: true,
          message: "分数不能大于99",
          type: "error",
        });
      }
    },
    // 合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      let value3 = []; //这里是分数的数组
      let value4 = []; //这里是题数的数组
      let reducesum = [];
      let news = [];
      let newstishu = "";
      columns.forEach((column, index) => {
        if (index === 2) {
          sums[index] = "合计";
          return;
        }
        const value = data.map((item) => Number(item[column.property]));
        if (index === 3) {
          value3 = JSON.stringify(value);
          value3 = JSON.parse(value3);
          // value3 = value;
        } else if (index === 4) {
          value4 = JSON.stringify(value);
          value4 = JSON.parse(value4);
          reducesum = value3.map((ztiem, zindex) => {
            return ztiem * value4[zindex];
          });
          //   console.log(reducesum);
          news = reducesum.reduce((total, num) => {
            return Number(total) + Number(num);
          }, 0);
          //   console.log(value3);
          //    console.log(value4);
          newstishu = value4.reduce((totals, nums) => {
            //   console.log(totals,nums);
            return Number(totals) + Number(nums);
          }, 0);
          //  console.log(news);
          //  console.log(newstishu);
          //  console.log(reducesum);
          //   console.log(sums);
          this.reducesum = news;
          this.$parent.reducesum = news;
          sums[index - 1] = news;
          sums[index - 1] += "分";
          sums[index] = newstishu;
          this.reducesumid = newstishu;
          sums[index] += "题";
        }
      });
      return sums;
    },
    // 上移
    onmoveup(index, row) {
      var that = this;
      console.log("上移", index, row);
      console.log(that.getData[index]);
      if (index > 0) {
        let upDate = that.getData[index - 1];
        that.getData.splice(index - 1, 1);
        that.getData.splice(index, 0, upDate);
      } else {
        alert("已经是第一条，不可上移");
      }
    },
    onmovedown(index, row) {
      var that = this;
      console.log("下移", index, row);
      if (index + 1 === that.getData.length) {
        alert("已经是最后一条，不可下移");
      } else {
        console.log(index);
        let downDate = that.getData[index + 1];
        that.getData.splice(index + 1, 1);
        that.getData.splice(index, 0, downDate);
      }
    },
    redcuezongfen() {
      console.log(this.getData);
      this.redcudesum = this.getData.reduce((first, scend, index) => {
        console.log(index);
        if (index == 1) {
          first = first.TestCount * first.Score;
        }
        //   console.log(firsts + scend.TestCount *scend.Score);
        return first + scend.TestCount * scend.Score;
      });
      this.getData.map((item) => {
        item["OldStyleName"] = item.OldStyleName
          ? item.OldStyleName
          : item.StyleName;
      });
      // console.log(res);
    },
    async saveunified_db() {
      //智能统一的保存调用。
      this.redcuezongfen();
      console.log(this.getData);
      let testinform = {};
      testinform["Score"] = this.redcudesum;
      testinform["Total"] = this.reducesumid;
      testinform["ShowCount"] = -1;
      let isreadtdata = {};
      isreadtdata["SelectCpt"] = this.$parent.pagetwodata;
      isreadtdata["Style"] = [];
      isreadtdata["Style"][0] = testinform;
      isreadtdata["Style"][1] = this.getData;
      let newconfigarr = [];
      newconfigarr[0] = testinform;
      newconfigarr[1] = this.getData;
      let parmas = {
        config: JSON.stringify(isreadtdata),
        newConfig: JSON.stringify(newconfigarr),
        paperID: this.$parent.testinfomation.PaperID,
        testShowCount: -1,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      let res = await editqusetionbank.addTest(qs.stringify(parmas));
      //这后面就是需要发cpt发送给父组件 8.27这里s
      this.$parent.SelectCpt = Object.values(this.$parent.pagetwodata).flat(2);
      this.$parent.Style["0"] = testinform;
      this.$parent.CookieCpt = this.$parent.pagetwodata;
      console.log(this.$parent.SelectCpt);
      console.log(JSON.stringify(this.$parent.Style)); //
      console.log(this.$parent.CookieCpt);
      this.cutcoms(1);
      this.destory();
    },
    // 难易度提交
   async submit_facility() {
      let newobj = {};
      let isscore = this.getData.every((item) => {
        // 分数不能为0，总题数不能为0 题数为0分数不能填写
        if (newobj[item.StyleName] === undefined) {
          newobj[item.StyleName] = "1";
        } else {
          this.$message.error("请不要输入相同的题型名称");
          return false;
        }
        if (item.StyleName === "") {
          this.$message.error("请输入正确的题目名称");
          return false;
        } else if (
          (item.easyTestcount > 0 ||
            item.mindleTestcount > 0 ||
            item.hardTestcount > 0) &&
          item.Score <= 0
        ) {
          this.$message.error("当前有题型分数为0");
          return false;
        } else {
          return true;
        }
      });
      if (this.$refs.facilitypage.numberamount <= 0) {
        this.$message.error("当前总题数为0");
        return;
      }
      // console.log(isscore);
      // 过滤掉垃圾数据
      this.getData = this.getData.filter((item) => {
        item.num =
          Number(item.easyTestcount) +
          Number(item.mindleTestcount) +
          Number(item.hardTestcount);
        if (item.num !== 0) {
          return item;
        }
      });
      // console.log(this.getData, "this.getData");
      if (!isscore) {
        return;
      }
      const parmas = {
        paperID: this.$parent.testinfomation.PaperID,
        config: JSON.stringify(this.getData),
        _examID:this.$parent.testinfomation.ExamID,
      }
      const {data} = await getappstyle.smartAddTest(parmas)
      if(data.Status == 200){
        this.cutcoms(1);
        this.destory();
      }else{
        this.$message.error(data.Data);
      }
      console.log(data, "难易度组卷22");
    },
    async saveunified_exam() {
      //试卷统一的保存调用
      //  this.$message("接口暂未处理好");
      this.redcuezongfen();
      console.log(this.getData);
      let testinform = {};
      testinform["Score"] = this.redcudesum;
      testinform["Total"] = this.reducesumid;
      testinform["ShowCount"] = -1;
      let isreadtdata = {};
      isreadtdata["SelectCpt"] = this.$parent.pagetwodata;
      isreadtdata["Style"] = [];
      isreadtdata["Style"][0] = testinform;
      isreadtdata["Style"][1] = this.getData;
      isreadtdata["ExamMode"] = "unified_exam";
      console.log(JSON.parse(this.$parent.paperinfomation[1].Config));
      isreadtdata["SelectCpt"] = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).CookieCpt;
      isreadtdata["CookieApp"] = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).CookieCpt;
      isreadtdata["softApp"] = JSON.parse(
        this.$parent.paperinfomation[1].Config
      ).SoftApp;
      let config = {
        config: JSON.stringify(isreadtdata),
        paperID: this.$parent.testinfomation.PaperID,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      let Data = await editqusetionbank.overridePaper(qs.stringify(config));

      if (Data.data.Status === 200) {
        this.cutcoms(1);
        this.destory();
      }
      if (Data.data.Status == "210") {
        this.$confirm(Data.data.Data, "提示", {
          confirmButtonText: "确定(返回试题设置)",
          type: "warning",
        })
          .then(() => {
            this.isrelease = false;
            this.isnowreasver = false;
          })
          .catch(() => {
            this.isrelease = false;
            this.isnowreasver = false;
          });
      }
    },
    isselect() {
      console.log(this.$parent.testinfomation.PaperMode);
      if (this.$parent.testinfomation.PaperMode == "unified_difflever") {
        // 难易度组卷
        this.submit_facility();
      } else if (
        this.$parent.testinfomation.PaperMode == "unified_db" ||
        this.$parent.testinfomation.PaperMode == "unified_Proportion" ||
        this.$parent.testinfomation.PaperMode == "sg_db" ||
        this.$parent.testinfomation.PaperMode == "paper"
      ) {
        this.saveunified_db(); //智能统一  精准手工  权重统一
      } else if (this.$parent.testinfomation.PaperMode == "unified_exam") {
        this.saveunified_exam(); //试卷统一
      }
    },
    destory() {
      this.$destroy();
    },
    //删除操作
    deletes(index) {
      this.$confirm("确认删除当前题型吗", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.getData.splice(index, 1);
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // });
        });
    },
    //智能统一的渲染题型调佣
    unified_db() {
      let parmas = {
        FilterHour: 0,
        config: JSON.stringify(this.$parent.pagetwodata),
        paperID: this.$parent.testinfomation.PaperID,
        testShowCount: -1,
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      getappstyle.getappstyle(parmas).then((res) => {
        console.log(res);
        this.getData = res.data.Data;
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
    //试卷统一的渲染题型调佣
    unified_exam() {
      let parmas = {
        paperStyleData: JSON.stringify(this.$parent.examdata.paperStyleData),
        paperID: this.$parent.testinfomation.PaperID,
        testShowCount: -1,
        paperStyleArr: JSON.stringify(this.$parent.examdata.paperStyleArr),
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        _examID: this.$parent.testinfomation.ExamID,
      };
      console.log(parmas);
      getTestStyle(parmas).then((res) => {
        console.log(res);
        this.getData = res.data.Data;
        setTimeout(() => {
          this.loading = false;
        }, 300);
      });
    },
    // 难易度组卷统一
    async facility_exam() {
      const date = {
        //智能组卷
        guid: JSON.parse(localStorage.getItem("userlist")).guid,
        hid: JSON.parse(localStorage.getItem("userlist")).hid,
        userID: JSON.parse(localStorage.getItem("userlist")).userID,
        config: JSON.stringify(this.$parent.pagetwodata),
      };
      this.loading = true;
      const { data } = await getappstyle.getdifficalArr(date);
      if (data.Status == 200) {
        setTimeout(() => {
          this.loading = false;
        }, 500);
        this.getData = data.Data.map((item) => {
          item.num = 0;
          item.Explain = "";
          return item;
        });
      } else {
        this.$message.error(data.Msg || data.Data);
      }
    },
  },
  activated() {
    // console.log(Object.values(this.$parent.pagetwodata).flat(2));
    this.groupmode = this.$parent.testinfomation.PaperMode;
    this.loading = true;
    if (
      this.$parent.testinfomation.PaperMode == "unified_db" ||
      this.$parent.testinfomation.PaperMode == "unified_Proportion" ||
      this.$parent.testinfomation.PaperMode == "sg_db" ||
      this.$parent.testinfomation.PaperMode == "paper"
    ) {
      this.unified_db(); //智能统一 权重统一 精准手工
    } else if (this.$parent.testinfomation.PaperMode == "unified_difflever") {
      this.facility_exam(); // 难易度组卷 统一命题
    } else if (this.$parent.testinfomation.PaperMode == "unified_exam") {
      this.unified_exam(); //试卷统一
    }
  },
};
</script>

<style lang="scss" scoped>
.showlabel {
  width: 100%;
  height: 98px;
  background-color: rgb(255, 255, 255);
  margin-bottom: 24px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  h4 {
    //background-color: antiquewhite;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 20px;
    color: #333333;
    padding-left: 24px;
    padding-right: 24px;
  }
  .testtype {
    padding-left: 24px;
    padding-right: 24px;
    height: 50px;
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 50px;
    margin-right: 50px;
    &:nth-child(4) {
      background-color: #1890ff;
      color: #ffffff;
      padding-left: 49px;
      padding-right: 49px;
      cursor: pointer;
    }
  }
}
.baic_content {
  background-color: white;
  //  margin-top: 24px;
  min-width: 1527px;
  padding-bottom: 50px;
  border-radius: 4px 4px 4px 4px;
}
::v-deep .el-textarea .el-input__count {
  position: absolute;
  bottom: 2px;
  right: 10px;
}
::v-deep .el-textarea__inner {
  line-height: 28px !important;
}

.operation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 60px 0 100px 0;
  .succ_btn {
    width: 162px;
    height: 50px;
    background: #eeeeee;
    color: #999999;
    margin-right: 90px;
  }
  .submit_btn {
    width: 162px;
    height: 50px;
    background: #0fc758;
    color: #ffffff;
  }
}
::v-deep .el-table .warning-row {
  background: #fff !important;
}

::v-deep .el-table .success-row {
  background: #f8fcff !important;
}
.small_input {
  width: 60px !important;
  height: 32px !important;
  font-size: 15px !important;
  margin-right: 10px;
}
.super_input {
  width: 78px !important;
  height: 32px !important;
  font-size: 15px !important;
  > ::v-deep .el-input__inner {
    padding: 0px 8px !important;
    text-align: center;
  }
}
.long_input {
  width: 420px;
  height: 100%;
}
::v-deep .el-input > .el-input__inner {
  height: 32px !important;
}
::v-deep .el-table th:nth-child(1) {
  opacity: 1;
  border-radius: 4px 0px 0px 4px;
}
::v-deep .el-table th:nth-child(7) {
  opacity: 1;
  border-radius: 0px 4px 4px 0px;
}
::v-deep .el-table th > .cell {
  align-items: center !important;
  text-align: center;
}
::v-deep td > .cell {
  color: #999999;
  font-size: 15px;
}
::v-deep.el-table--enable-row-transition .el-table__body td {
  text-align: center;
}
::v-deep .has-gutter {
  height: 70px;
  tr > td {
    background-color: #f5faff;
  }

  .cell {
    text-align: center;
  }
}
.nomove {
  opacity: 0;
  cursor: auto;
}
</style>